<template>
  <Layout>
    <ServerStatusListPage
      title="Rejected Applications"
      subtitle="Membership applications that were declined."
      card-title="Rejected"
      icon="x-circle"
      tone="red"
      by-label="Rejected By"
      search-placeholder="Search rejected application..."
      empty-message="No rejected applications"
      endpoint="/applications/rejected_applications/"
      :status="status"
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import ServerStatusListPage from "@/components/shared/ServerStatusListPage.vue";
import { APPLICATION_STATUS } from "@/constants";

// Shared by staff and admin; paging / search / sort are server-side and kept in the URL.
export default {
  components: {
    Layout,
    ServerStatusListPage,
  },
  data() {
    return { status: APPLICATION_STATUS.REJECTED };
  },
};
</script>